module.exports = __webpack_public_path__ + "static/media/bg.b11f510d.jpg";